import styled from 'styled-components';

const LogoPlaceholder = styled.div`
  width: 32px;
  height: 32px;
  background-color: #ffffff;
`;

export default LogoPlaceholder;
